import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { styled } from '../../utils';
import { FormFlex } from '../FormGrid/FormFlex';
import { Icon } from '../Icon/Icon';
import { Tooltip } from '../Tooltip/Tooltip';
import { Typography } from '../Typography/Typography';
import { SelectableCard } from './SelectableCard';
const TitleTypographyStyled = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));
const ErrorMessageWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    columnGap: theme.spacing(1),
    alignItems: 'center',
}));
export function SelectableCardGroup({ title, value, options, onChange, error, helperText, disabled, tooltip, direction = 'row', align = 'center', }) {
    useEffect(() => {
        // Select value automatically if there is only one option and it has not been selected yet
        if (options.length === 1 && options[0].value !== value) {
            onChange(options[0].value);
        }
    }, [onChange, options, value]);
    return (_jsxs(FormFlex, { columnGap: 0, rowGap: 1, flexGrow: 1, flexDirection: "column", children: [title && (_jsxs(TitleTypographyStyled, { variant: "subtitle1", color: disabled ? 'GrayText' : undefined, children: [title, tooltip && _jsx(Tooltip, { disabled: disabled, description: tooltip })] })), _jsx(FormFlex, { rowGap: 2, columnGap: 2, width: "auto", flexGrow: 1, sx: (theme) => ({
                    flexDirection: direction,
                    [theme.breakpoints.down('sm')]: {
                        flexDirection: 'column',
                    },
                }), flexBasis: 0, children: options.map((option, i) => (_createElement(SelectableCard, { ...option, disabled: disabled ? disabled : option.disabled, error: error ? error : option.error, selected: options.length === 1 ? true : !disabled && option.value === value, key: i, onClick: () => option.value !== value && onChange(option.value), align: align }))) }), error && !disabled && helperText && (_jsxs(ErrorMessageWrapper, { children: [_jsx(Icon, { variant: "alert-circle", fontSize: "small", color: "error" }), _jsx(Typography, { color: "error", variant: "body1", children: helperText })] }))] }));
}
